import { getCustomerDevelop, creatCustomerDevelop, getCustomerDevelopById, customerDevelopOperate, deleteCustomerDevelop } from '@/api/customerDevelop'
import Vue from 'vue'

const state = {
  customerDevelops: [],
  customerDevelopOne: {},
  customerDevelopForCustomer: [],
  totalCounts: 0,
}

const getters = {
  customerDevelopById: (state) => (id) => {
    return state.customerDevelops.find(x => x._id === id)
  },
  getApplyingCustomerDevelop: (state) => (id) => {
    return state.customerDevelops.filter(x => x._id === id)
  }
}

const actions = {
  async getCustomerDevelopAction({ commit }, payload) {
    try {
      const res = await getCustomerDevelop(payload)
      commit('SETCUSTOMERDEVELOPLIST', res.data)
      return res.data.customerDevelopList
    } catch (error) {
      throw error
    }
  },
  async getCustomerDevelopForCustomerAction({ commit }, payload) {
    try {
      const res = await getCustomerDevelop(payload)
      commit('SET_CUSTOMERDEVELOPLIST_FORCUSTOMER', res.data)
      return res.data.customerDevelopList
    } catch (error) {
      throw error
    }
  },

  async getCustomerDevelopByIdAction({ commit }, payload) {
        try {
            const customerDevelopOne = await getCustomerDevelopById(payload)
            return customerDevelopOne.data
        } catch (error) {
            throw error.message
        }
    },

  async creatCustomerDevelopAction({ commit }, payload) {
    try{
      const newCustomerDevelop = await creatCustomerDevelop(payload);
      commit('ADDNEWTECHSERVICE', newCustomerDevelop.data)
    }catch (error) {
      throw error.message
    }
  },

  async customerDevelopOperateAction({ commit }, payload) {
    try {
      const newCustomerDevelop = await customerDevelopOperate(payload.id, payload.data);
      commit('CUSTOMERDEVOPERATE', newCustomerDevelop.data)
      return newCustomerDevelop.data
    } catch (error) {
      throw error
    }
  },

  async deleteCustomerDevelopAction({ commit }, payload) {
    try {
      await deleteCustomerDevelop(payload.id, payload.status)
      commit('DELETECUSTOMERDEVELOP', payload.id)
      return payload.id
    } catch (error) {
        throw error.message
    }
    }
}

const mutations = {
  SETCUSTOMERDEVELOPLIST(state, payload) {
    state.customerDevelops = payload.customerDevelopList
    state.customerDevelopForCustomer = payload.customerDevelopList
    state.totalCounts = payload.totalCounts
  },
  SET_CUSTOMERDEVELOPLIST_FORCUSTOMER(state, payload) {
    state.customerDevelopForCustomer = payload.customerDevelopList
    state.totalCounts = payload.totalCounts
  },
  ADDNEWTECHSERVICE(state, customerDevelop) {
    state.customerDevelops.unshift(customerDevelop)
    state.totalCounts++
  },
  CUSTOMERDEVOPERATE(state, customerDevelop) {
    Vue.set(state.customerDevelopForCustomer, state.customerDevelopForCustomer.findIndex(x => x._id === customerDevelop._id), customerDevelop)
  },
  DELETECUSTOMERDEVELOP(state, id) {
    state.customerDevelops = state.customerDevelops.filter(e => e._id !== id)
    state.totalCounts--
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}